import type { HydratedModulesById } from "~types/types";

type NextPageApiRequest = {
    id: string;
    pageId: string;
    offset: number;
    variation: string;
    type: string;
    signal?: AbortSignal;
};

export async function fetchNextPageFromApi({
    id,
    pageId,
    offset,
    variation,
    type,
    signal,
}: NextPageApiRequest) {
    const nextPageResponse = await fetch(
        `/lineup-next/api/paginate?id=${id}&page=${pageId}&offset=${offset}&variation=${variation}&type=${type}`,
        { signal }
    );

    if (!nextPageResponse.ok) {
        throw new Error(
            `Error when fetching from api/paginate: ${await nextPageResponse.text()}`
        );
    }

    return (await nextPageResponse.json()) as HydratedModulesById;
}
